<script setup>
defineProps({
  customSvgStyle: {
    required: false,
    type: Object,
    default: () => ({})
  }
})
</script>

<template>
  <div class="agri-inline-loader">
    <svg
      class="agri-inline-loader__logo"
      viewBox="0 0 161 164"
      role="img"
      :aria-label="$t('shared.common.loading')"
      :style="customSvgStyle"
    >
      <g class="agri-inline-loader__emblem">
        <g class="agri-inline-loader__piece agri-inline-loader__piece--1">
          <path
            d="M18.42 30.52h2.94L41 30.45v-.01h5.94c.79 0 1.55-.35 2.05-.96L65.87 9.17a2.67 2.67 0 012.05-.96h47.45c.9 0 1.89-.73 2.21-1.62l1.51-4.16c.33-.9-.14-1.62-1.03-1.62h-53.6c-.79 0-1.55.35-2.05.96L45.49 22.1c-.51.61-1.26.96-2.05.96H41v-.01l-20.22.07v.03c-.8.15-1.6.8-1.88 1.59l-1.51 4.16c-.32.9.14 1.62 1.03 1.62z"
          />
        </g>

        <g class="agri-inline-loader__piece agri-inline-loader__piece--2">
          <path
            d="M152.05 30.45h-.29v-.01h-40.65a.39.39 0 01-.3-.64l5.64-6.78h25c1.11 0 2.01-.9 2.01-2.01v-3.38c0-1.11-.9-2.01-2.01-2.01H68.77a.39.39 0 00-.3.14L50.18 37.74c-.07.09-.18.14-.3.14H14.02c-.02 0-.04-.01-.07-.01h-2.92c-.9 0-1.89.73-2.21 1.62l-1.51 4.16c-.33.9.14 1.62 1.03 1.62h2.92c.06 0 .12-.01.18-.02.03.01.06.02.1.02l27.54-.02h10.81c.12 0 .22.05.3.14l18.29 21.98c.07.09.18.14.3.14h64.08c.05 0 .1-.01.14-.03h.07c1.48 0 2.67-1.2 2.67-2.67v-2.07c0-1.47-1.2-2.67-2.67-2.67h-10.74v.03h-5.88l.02-.04-5.63-6.77a.391.391 0 01.3-.64h33.89c1.11 0 2.01-.9 2.01-2.01v-3.38c0-1.11-.9-2.01-2.01-2.01H104.33a.39.39 0 01-.3-.14l-2.76-3.32a.392.392 0 010-.5l2.75-3.31c.07-.09.18-.14.3-.14h45.15c.02 0 .04.01.06.01h2.53c1.11 0 2.01-.9 2.01-2.01v-3.38a2.025 2.025 0 00-2.02-2.01zm-90.68 4.84l10.69-12.74c.3-.35.73-.56 1.19-.56h8.44c1.32 0 2.04 1.54 1.19 2.56L72.19 37.29c-.25.3-.79.55-1.19.55h-8.44c-1.32.01-2.04-1.53-1.19-2.55zm20.32 25.85h-8.44c-.46 0-.9-.2-1.19-.56L61.37 47.84c-.85-1.01-.13-2.56 1.19-2.56H71c.4 0 .93.25 1.19.55l10.69 12.74c.85 1.02.13 2.57-1.19 2.57zm23.39-2.56c.85 1.01.13 2.56-1.19 2.56h-8.44c-.46 0-.9-.2-1.19-.56L83.57 47.84c-.85-1.01-.13-2.56 1.19-2.56h8.44c.4 0 .93.25 1.19.55l10.69 12.75zm0-34.02L94.39 37.3c-.26.3-.79.55-1.19.55h-8.44c-1.32 0-2.04-1.54-1.19-2.56l10.69-12.74c.3-.35.73-.56 1.19-.56h8.44c1.32.01 2.04 1.55 1.19 2.57z"
          />
        </g>

        <g class="agri-inline-loader__piece agri-inline-loader__piece--3">
          <path
            d="M48.42 52.68H18.48v.14c-.66.25-1.27.82-1.51 1.48l-1.51 4.16c-.33.9.14 1.62 1.03 1.62H45.73c.9 0 1.89-.73 2.21-1.62l1.51-4.16c.33-.9-.13-1.62-1.03-1.62z"
          />
        </g>
      </g>

      <g class="agri-inline-loader__word">
        <path
          d="M54.4 106.12v57.75H31.45c-3.83 0-5.58-1.75-5.58-5.58V140.9c0-4.05 1.97-5.91 6.02-5.91h12.15v-19.25h-7.77v9.63h-10.4v-13.35c0-3.94 1.97-5.91 6.02-5.91H54.4v.01zm-10.36 36.75h-7.77v12.47h7.77v-12.47zM20.99 154.25v9.63H10.38c-3.94 0-5.91-1.97-5.91-5.91v-42.22H.64v-9.63h3.83V86.87h10.39v19.25h6.13v9.63h-6.13v38.5h6.13zM104.62 96.5v9.63h7.17v9.61h-7.17v48.15H94.23v-48.15H90.4v-9.61h3.83V92.78c0-3.94 1.97-5.91 5.91-5.91h11.65v9.63h-7.17zM116.67 106.11h10.39v57.76h-10.39zM116.67 86.85h10.39v9.61h-10.39zM155.03 106.12c3.83 0 5.58 1.86 5.58 5.58v52.18h-10.5v-48.13h-7.66v48.13h-10.5v-57.75h23.08v-.01zM82.37 106.12c3.83 0 5.47 1.86 5.47 5.58v13.66H77.45v-9.62h-7.66v48.13h-10.5v-57.75h23.08z"
        />
      </g>
    </svg>

    <div class="agri-inline-loader__rail"><i /></div>
  </div>
</template>

<style scoped>
.agri-inline-loader {
  --agri-brand: #32a84b;
  --agri-dark: #0a220f;
  --agri-dim: rgba(10, 34, 15, 0.13);
  --agri-ease: cubic-bezier(0.4, 0, 0.2, 1);
  --agri-build-speed: 3.6s;
  --agri-rail-speed: 1.9s;
  --agri-logo-w: 5rem;
  --agri-rail-w: calc(var(--agri-logo-w) * 1.27);

  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
}

.agri-inline-loader__logo {
  width: 100%;
  max-width: var(--agri-logo-w);
  height: auto;
  display: block;
  overflow: visible;
}

.agri-inline-loader__word {
  fill: var(--agri-dark);
}

.agri-inline-loader__emblem {
  fill: var(--agri-brand);
}

.agri-inline-loader__piece {
  opacity: 0;
  animation-duration: var(--agri-build-speed);
  animation-timing-function: var(--agri-ease);
  animation-iteration-count: infinite;
}

.agri-inline-loader__piece--1 {
  animation-name: agri-inline-in-1;
}

.agri-inline-loader__piece--2 {
  animation-name: agri-inline-in-2;
}

.agri-inline-loader__piece--3 {
  animation-name: agri-inline-in-3;
}

@keyframes agri-inline-in-1 {
  0% {
    opacity: 0;
    transform: translateY(-3px);
  }
  11%,
  78% {
    opacity: 1;
    transform: translateY(0);
  }
  88%,
  100% {
    opacity: 0;
    transform: translateY(0);
  }
}

@keyframes agri-inline-in-2 {
  0%,
  18% {
    opacity: 0;
    transform: translateY(-3px);
  }
  29%,
  78% {
    opacity: 1;
    transform: translateY(0);
  }
  88%,
  100% {
    opacity: 0;
    transform: translateY(0);
  }
}

@keyframes agri-inline-in-3 {
  0%,
  36% {
    opacity: 0;
    transform: translateY(-3px);
  }
  47%,
  78% {
    opacity: 1;
    transform: translateY(0);
  }
  88%,
  100% {
    opacity: 0;
    transform: translateY(0);
  }
}

.agri-inline-loader__rail {
  width: 100%;
  max-width: var(--agri-rail-w);
  height: 2px;
  background: var(--agri-dim);
  position: relative;
  overflow: hidden;
}

.agri-inline-loader__rail i {
  position: absolute;
  inset: 0;
  display: block;
  background: var(--agri-brand);
  transform-origin: left center;
  animation: agri-inline-rail-stretch var(--agri-rail-speed) linear infinite;
}

@keyframes agri-inline-rail-stretch {
  0% {
    transform: translateX(0%) scaleX(0.28);
  }
  12.5% {
    transform: translateX(5%) scaleX(0.39);
  }
  25% {
    transform: translateX(25%) scaleX(0.5);
  }
  37.5% {
    transform: translateX(56%) scaleX(0.39);
  }
  50% {
    transform: translateX(72%) scaleX(0.28);
  }
  62.5% {
    transform: translateX(56%) scaleX(0.39);
  }
  75% {
    transform: translateX(25%) scaleX(0.5);
  }
  87.5% {
    transform: translateX(5%) scaleX(0.39);
  }
  100% {
    transform: translateX(0%) scaleX(0.28);
  }
}

@media (prefers-reduced-motion: reduce) {
  .agri-inline-loader__piece,
  .agri-inline-loader__rail i {
    animation: none;
  }

  .agri-inline-loader__piece {
    opacity: 1;
    transform: none;
  }

  .agri-inline-loader__rail i {
    transform: scaleX(1);
    opacity: 0.5;
  }
}
</style>
